import { render, staticRenderFns } from "./NewsOverview.vue?vue&type=template&id=1ba035c4&scoped=true&"
import script from "./NewsOverview.vue?vue&type=script&lang=js&"
export * from "./NewsOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba035c4",
  null
  
)

export default component.exports